import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TrainingApp as TrainingAppComponent } from '../components/apps/apps/TrainingApp';
export function TrainingApp() {
    return (_jsx("div", { className: "h-full", children: _jsx(TrainingAppComponent, {}) }));
}
